export const applyThemeJson = (rebrand) => {
  const style = getComputedStyle(document.documentElement);
  const fetch = (property) => {
    if (property.includes("innercontainer")) {
      document
        ?.querySelectorAll('[contentpanelname="INTERACTION_PARENT_NEW"]')
        ?.forEach((inte) => {
          inte &&
            (inte.style.backgroundColor = rebrand
              ? style?.getPropertyValue(property + rebrand)?.trim()
              : style?.getPropertyValue(property)?.trim());
        });
    }
    // console.log(rebrand);
    const value = rebrand
      ? style?.getPropertyValue(property + rebrand)?.trim()
      : style?.getPropertyValue(property)?.trim();
    let isFixedVariable = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--sjs-header-fixed-ctm" + rebrand);
    localStorage.setItem("isFixedHeaderVariable", isFixedVariable);
    return value;
  };

  let json = {
    themeName: "default",
    colorPalette: "light",
    isPanelless: false,
    backgroundImage: "",
    backgroundOpacity: 1,
    backgroundImageAttachment: "scroll",
    backgroundImageFit: "cover",
    cssVariables: {
      "--sjs-primary-backcolor": fetch("--sjs-primary-backcolor-ctm"),
      "--sjs-font-family": fetch("--sjs-font-family-ctm"),
      "--sjs-general-forecolor": fetch("--sjs-general-forecolor-ctm"),
      "--sjs-font-questiontitle-weight": fetch(
        "--sjs-font-questiontitle-weight-ctm"
      ),
      "--sjs-font-questiontitle-size": fetch(
        "--sjs-font-questiontitle-size-ctm"
      ),
      "--sjs-font-questiondescription-color": fetch(
        "--sjs-font-questiondescription-color-ctm"
      ),
      "--sjs-font-questiondescription-size": fetch(
        "--sjs-font-questiondescription-size-ctm"
      ),
      "--sjs-font-questiondescription-weight": fetch(
        "--sjs-font-questiondescription-weight-ctm"
      ),
      "--sjs-internal-font-editorfont-size": fetch(
        "--sjs-internal-font-editorfont-size-ctm"
      ),
      "--sjs-general-backcolor": fetch("--sjs-general-backcolor-ctm"),
      "--sjs-general-backcolor-dark": fetch("--sjs-general-backcolor-ctm"),
      "--sjs-general-backcolor-dim-light":
        fetch("--sjs-general-backcolor-dim-ctm") + "1a",
      "--sjs-general-backcolor-dim": fetch("--sjs-general-backcolor-dim-ctm"),
      "--sjs-general-backcolor-dim-dark": fetch(
        "--sjs-general-backcolor-dim-ctm"
      ),
      "--sjs-mobile-accordion-svg": fetch("--sjs-mobile-accordion-svg-ctm"),
      "--sjs-general-backcolor-innercontainer-dim": fetch(
        "--sjs-general-backcolor-innercontainer-dim-ctm"
      ),
"--sjs-font-impact-survey-bg-color": fetch("--sjs-font-impact-survey-bg-color-ctm"),
"--sjs-font-impact-survey-box-bg-color": fetch("--sjs-font-impact-survey-box-bg-color-ctm"),
"--sjs-font-impact-survey-heading-family": fetch("--sjs-font-impact-survey-heading-family-ctm"),
"--sjs-font-impact-survey-heading-size": fetch("--sjs-font-impact-survey-heading-size-ctm"),
"--sjs-font-impact-survey-heading-weight": fetch("--sjs-font-impact-survey-heading-weight-ctm"),
"--sjs-font-impact-survey-body-family": fetch("--sjs-font-impact-survey-body-family-ctm"),
"--sjs-font-impact-survey-body-size": fetch("--sjs-font-impact-survey-body-size-ctm"),
"--sjs-font-impact-survey-body-weight": fetch("--sjs-font-impact-survey-body-weight-ctm"),
"--sjs-font-impact-survey-submit-bg-color": fetch("--sjs-font-impact-survey-submit-bg-color-ctm"),
"--sjs-font-impact-survey-submit-hover-bg-color": fetch("--sjs-font-impact-survey-submit-hover-bg-color-ctm"),
"--sjs-font-impact-survey-submit-size": fetch("--sjs-font-impact-survey-submit-size-ctm"),
"--sjs-font-impact-survey-submit-weight": fetch("--sjs-font-impact-survey-submit-weight-ctm"),
"--sjs-font-impact-survey-submit-text-color": fetch("--sjs-font-impact-survey-submit-text-color-ctm"),
"--sjs-font-impact-survey-submit-text-color-hover": fetch("--sjs-font-impact-survey-submit-text-color-hover-ctm"),
"--sjs-font-impact-survey-small-box-bg-color": fetch("--sjs-font-impact-survey-small-box-bg-color-ctm"),
"--sjs-font-impact-survey-small-box-border-color": fetch("--sjs-font-impact-survey-small-box-border-color-ctm"),
"--sjs-font-impact-survey-submit-letter-spacing": fetch("--sjs-font-impact-survey-submit-letter-spacing-ctm"),
"--sjs-font-impact-survey-submit-line-height": fetch("--sjs-font-impact-survey-submit-line-height-ctm"),
"--sjs-font-impact-survey-submit-font-style": fetch("--sjs-font-impact-survey-submit-font-style-ctm"),
"--sjs-font-impact-survey-body-letter-spacing": fetch("--sjs-font-impact-survey-body-letter-spacing-ctm"),
"--sjs-font-impact-survey-body-line-height": fetch("--sjs-font-impact-survey-body-line-height-ctm"),
"--sjs-font-impact-survey-body-font-style": fetch("--sjs-font-impact-survey-body-font-style-ctm"),
"--sjs-font-impact-survey-heading-letter-spacing": fetch("--sjs-font-impact-survey-heading-letter-spacing-ctm"),
"--sjs-font-impact-survey-heading-line-height": fetch("--sjs-font-impact-survey-heading-line-height-ctm"),
"--sjs-font-impact-survey-heading-font-style": fetch("--sjs-font-impact-survey-heading-font-style-ctm"),
"--sjs-font-impact-survey-submit-family": fetch("--sjs-font-impact-survey-submit-family-ctm"),
"--sjs-font-impact-survey-body-link-color": fetch("--sjs-font-impact-survey-body-link-color-ctm"),
"--sjs-font-impact-survey-body-link-color-hover": fetch("--sjs-font-impact-survey-body-link-color-hover-ctm"),
"--sjs-font-impact-survey-submit-border-color": fetch("--sjs-font-impact-survey-submit-border-color-ctm"),
"--sjs-font-impact-survey-submit-border-color-hover": fetch("--sjs-font-impact-survey-submit-border-color-hover-ctm"),
'--sjs-font-impact-survey-heading-size-mob': fetch('--sjs-font-impact-survey-heading-size-mob-ctm'),
'--sjs-font-impact-survey-heading-line-height-mob': fetch('--sjs-font-impact-survey-heading-line-height-mob-ctm'),
'--sjs-font-impact-survey-body-size-mob': fetch('--sjs-font-impact-survey-body-size-mob-ctm'),
'--sjs-font-impact-survey-body-line-height-mob': fetch('--sjs-font-impact-survey-body-line-height-mob-ctm'),
'--sjs-font-impact-survey-submit-size-mob': fetch('--sjs-font-impact-survey-submit-size-mob-ctm'),
'--sjs-font-impact-survey-submit-line-height-mob': fetch('--sjs-font-impact-survey-submit-line-height-mob-ctm'),
    },
    headerView: "basic",
  };
  // setTimeout(() => {
  applyThemeForInteractiveFeature(rebrand, style);
  // }, 1500);

  return json?.cssVariables;
};

const fetchPropertyValue = (property, style) => {
  let val = style?.getPropertyValue(property)?.trim();
  return val;
};

export const applyThemeForInteractiveFeature = (rebrand, style) => {
  const element = document.querySelector(".interaction-bar");
  const impactElement = document.querySelector(".IMPACT-SURVEY-PARENT");
  if (!rebrand) rebrand = "";

  addContainerOnInteractionBar(rebrand, style);

  //common
  element.style.setProperty(
    "--sjs-font-bar-bg-family-dynamic",
    fetchPropertyValue(`--sjs-font-bar-bg-family-ctm${rebrand}`, style)
  );
  element.style.setProperty(
    "--sjs-font-bar-bg-color-dynamic",
    fetchPropertyValue(`--sjs-font-bar-bg-color-ctm${rebrand}`, style)
  );
  element.style.setProperty(
    "--sjs-font-bar-font-color-dynamic",
    fetchPropertyValue(`--sjs-font-bar-font-color-ctm${rebrand}`, style)
  );

  //title
  element.style.setProperty(
    "--sjs-font-bar-title-size-dynamic",
    fetchPropertyValue(`--sjs-font-bar-title-size-ctm${rebrand}`, style)
  );
  element.style.setProperty(
    "--sjs-font-bar-title-weight-dynamic",
    fetchPropertyValue(`--sjs-font-bar-title-weight-ctm${rebrand}`, style)
  );

  //description
  element.style.setProperty(
    "--sjs-font-bar-description-size-dynamic",
    fetchPropertyValue(`--sjs-font-bar-description-size-ctm${rebrand}`, style)
  );
  element.style.setProperty(
    "--sjs-font-bar-description-weight-dynamic",
    fetchPropertyValue(`--sjs-font-bar-description-weight-ctm${rebrand}`, style)
  );

  //complate
  element.style.setProperty(
    "--sjs-font-bar-complete-size-dynamic",
    fetchPropertyValue(`--sjs-font-bar-complete-size-ctm${rebrand}`, style)
  );
  element.style.setProperty(
    "--sjs-font-bar-complete-weight-dynamic",
    fetchPropertyValue(`--sjs-font-bar-complete-weight-ctm${rebrand}`, style)
  );

  //auto
  element.style.setProperty(
    "--sjs-font-bar-auto-size-dynamic",
    fetchPropertyValue(`--sjs-font-bar-auto-size-ctm${rebrand}`, style)
  );
  element.style.setProperty(
    "--sjs-font-bar-auto-weight-dynamic",
    fetchPropertyValue(`--sjs-font-bar-auto-weight-ctm${rebrand}`, style)
  );

  //submit
  element.style.setProperty(
    "--sjs-font-bar-submit-bg-color-dynamic",
    fetchPropertyValue(`--sjs-font-bar-submit-bg-color-ctm${rebrand}`, style)
  );
  element.style.setProperty(
    "--sjs-font-bar-submit-hover-bg-color-dynamic",
    fetchPropertyValue(
      `--sjs-font-bar-submit-hover-bg-color-ctm${rebrand}`,
      style
    )
  );
  element.style.setProperty(
    "--sjs-font-bar-submit-font-color-dynamic",
    fetchPropertyValue(`--sjs-font-bar-submit-font-color-ctm${rebrand}`, style)
  );
  element.style.setProperty(
    "--sjs-font-bar-submit-size-dynamic",
    fetchPropertyValue(`--sjs-font-bar-submit-size-ctm${rebrand}`, style)
  );
  element.style.setProperty(
    "--sjs-font-bar-submit-weight-dynamic",
    fetchPropertyValue(`--sjs-font-bar-submit-weight-ctm${rebrand}`, style)
  );
  if(impactElement) {
  impactElement.style.setProperty(
  "--sjs-font-bar-bg-family-dynamic",
  fetchPropertyValue(`--sjs-font-bar-bg-family-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-bg-color-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-bg-color-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-box-bg-color-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-box-bg-color-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-heading-family-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-heading-family-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-heading-size-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-heading-size-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-heading-weight-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-heading-weight-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-heading-letter-spacing-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-heading-letter-spacing-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-heading-line-height-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-heading-line-height-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-heading-font-style-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-heading-font-style-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-body-family-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-body-family-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-body-size-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-body-size-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-body-weight-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-body-weight-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-body-letter-spacing-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-body-letter-spacing-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-body-line-height-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-body-line-height-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-body-font-style-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-body-font-style-ctm${rebrand}`, style)
  );

    impactElement.style.setProperty(
    "--sjs-font-impact-survey-body-link-color-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-body-link-color-ctm${rebrand}`, style)
  );

      impactElement.style.setProperty(
    "--sjs-font-impact-survey-body-link-color-hover-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-body-link-color-hover-ctm${rebrand}`, style)
  );
  
  impactElement.style.setProperty(
  "--sjs-font-impact-survey-submit-family-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-submit-family-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
  "--sjs-font-impact-surve-submit-bg-color-dynamic",
  fetchPropertyValue(`--sjs-font-impact-surve-submit-bg-color-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-surve-submit-hover-bg-color-dynamic",
    fetchPropertyValue(`--sjs-font-impact-surve-submit-hover-bg-color-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-submit-size-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-submit-size-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-submit-weight-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-submit-weight-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-submit-text-color-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-submit-text-color-ctm${rebrand}`, style)
  );
    impactElement.style.setProperty(
    "--sjs-font-impact-survey-submit-text-color-hover-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-submit-text-color-hover-ctm${rebrand}`, style)
  );
    impactElement.style.setProperty(
  "--sjs-font-impact-survey-submit-letter-spacing-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-submit-letter-spacing-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-submit-line-height-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-submit-line-height-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-submit-font-style-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-submit-font-style-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-submit-border-color-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-submit-border-color-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-submit-border-color-hover-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-submit-border-color-hover-ctm${rebrand}`, style)
  );

  

  impactElement.style.setProperty(
    "--sjs-font-impact-surve-small-box-bg-color-dynamic",
    fetchPropertyValue(`--sjs-font-impact-surve-small-box-bg-color-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-impact-survey-small-box-border-color-dynamic",
    fetchPropertyValue(`--sjs-font-impact-survey-small-box-border-color-ctm${rebrand}`, style)
  );

    //complate
  impactElement.style.setProperty(
    "--sjs-font-bar-complete-size-dynamic",
    fetchPropertyValue(`--sjs-font-bar-complete-size-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-bar-complete-weight-dynamic",
    fetchPropertyValue(`--sjs-font-bar-complete-weight-ctm${rebrand}`, style)
  );

  //auto
  impactElement.style.setProperty(
    "--sjs-font-bar-auto-size-dynamic",
    fetchPropertyValue(`--sjs-font-bar-auto-size-ctm${rebrand}`, style)
  );
  impactElement.style.setProperty(
    "--sjs-font-bar-auto-weight-dynamic",
    fetchPropertyValue(`--sjs-font-bar-auto-weight-ctm${rebrand}`, style)
  );

  //Mobile view variables
impactElement.style.setProperty(
  "--sjs-font-impact-survey-heading-size-mob-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-heading-size-mob-ctm${rebrand}`, style)
);
impactElement.style.setProperty(
  "--sjs-font-impact-survey-heading-line-height-mob-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-heading-line-height-mob-ctm${rebrand}`, style)
);
impactElement.style.setProperty(
  "--sjs-font-impact-survey-body-size-mob-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-body-size-mob-ctm${rebrand}`, style)
);
impactElement.style.setProperty(
  "--sjs-font-impact-survey-body-line-height-mob-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-body-line-height-mob-ctm${rebrand}`, style)
);
impactElement.style.setProperty(
  "--sjs-font-impact-survey-submit-size-mob-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-submit-size-mob-ctm${rebrand}`, style)
);
impactElement.style.setProperty(
  "--sjs-font-impact-survey-submit-line-height-mob-dynamic",
  fetchPropertyValue(`--sjs-font-impact-survey-submit-line-height-mob-ctm${rebrand}`, style)
);
  }
};

const addContainerOnInteractionBar = (rebrand, style) => {
  let val_ = style
    ?.getPropertyValue(
      `--sjs-general-backcolor-innercontainer-dim-ctm${rebrand}`
    )
    ?.trim();
  const interactionBar = document?.querySelector(".interaction-bar");
  if (
    val_ &&
    interactionBar &&
    !interactionBar?.classList?.contains("container")
  ) {
    interactionBar.classList.add("container");
  }
};
